module.exports = __webpack_public_path__ + "img/img22.9fff76af.png";